export const MAX_GRID_CELLS = 10;

export const TECH_WEIGHTS = {
  eólica: 1,
  fotovoltaica: 1,
  "ciclo combinado": 3,
  hidráulica: 1,
  nuclear: 8,
  carbón: 4,
};
